/* unplugin-vue-components disabled */import script from "./topSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./topSearch.vue?vue&type=script&setup=true&lang=js"

import "./topSearch.vue?vue&type=style&index=0&id=77e7335c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e7335c"]])

export default __exports__